export const FORM_TYPES = {
  DIETITIAN: "dietitian",
} as const;

export const FILTER_TYPE = {
  IS_LESS_THAN: "is_less_than",
  IS_LEES_THAN_OR_EQUAL_TO: "is_less_than_or_equal_to",
  IS_GREATER_THAN: "is_greater_than",
  IS_GREATER_THAN_OR_EQUAL_TO: "is_greater_than_or_equal_to",
  IS_EQUAL_TO: "is_equal_to",
  IS_NOT_EQUAL_TO: "is_not_equal_to",
  INCLUDES: "includes",
  CONTAINS: "contains",
  DOES_NOT_INCLUDE: "does_not_include",
  DOES_NOT_CONTAIN: "does_not_contain",
} as const;

export const FIELD_TYPE = {
  CHECKBOX: "checkbox",
  DROPDOWN: "dropdown",
  HORIZONTAL_RADIO: "horizontal_radio",
  RADIO: "radio",
  READ_ONLY: "read_only",
  READ_ONLY_LINK: "read_only_link",
  TEXT: "text",
  TEXTAREA: "textarea",
  FILE: "document_upload",
  HIDDEN: "hidden",
  NUMBER: "number",
} as const;
